<template lang="pug">
  .collection-grid--wrapper(v-if="collection")
    .collection-grid(v-if="explodedProducts")
      transition(v-if="collection" name="fade" mode="out-in")
        .row(
          :class="gridClasses"
        )
          .column(
            v-for="item in explodedProducts"
            :key="item.title"
          )
            product-subscription-tile(
              :product="item"
              v-if="useSubTiles"
            )
            product-tile(
              :product="item"
              :bs_color="bs_color"
              :np_color="np_color"
              :nr_color="nr_color"
              :so_color="so_color"
              :le_color="le_color"
              v-else
            )
</template>

<script>
  import { mapState } from 'vuex';

  import Pagination from 'scripts/components/basic/Pagination.vue';
  import ProductTile from 'scripts/components/product/ProductTile.vue';
  import ProductSubscriptionTile from 'scripts/components/product/ProductSubscriptionTile.vue';

  export default {
    name: 'CollectionGrid',
    components: {
      Pagination,
      ProductTile,
      ProductSubscriptionTile,
    },
    props: {
      handle: String,
      useSubTiles: {
        type: Boolean,
        default: false,
      },
      bs_color: {
        type: String,
        default: '#0A2B6F'
      },
      np_color: {
        type: String,
        default: '#0A2B6F'
      },
      nr_color: {
        type: String,
        default: '#0A2B6F'
      },
      so_color: {
        type: String,
        default: '#0A2B6F'
      },
      le_color: {
        type: String,
        default: '#0A2B6F'
      },
    },
    computed: {
      ...mapState({
        collections: state => state.collections.all,
      }),
      collection () {
        return this.collections.find(collection => collection.handle === this.handle);
      },
      explodedProducts () {
        if (!this.collection) return [];
        return this.collection.products;
      },
      gridClasses() {
        if (this.useSubTiles === true) return 'small-up-1 large-up-2';
        return 'small-up-2 medium-up-3';
      }
    },
    created () {
      const urlParams = new URLSearchParams(window.location.search);
      const pageNumber = urlParams.get('page');

      this.$store.dispatch('collections/addCollection', {
        handle: this.handle,
        page: pageNumber,
      });
    },
  };
</script>

<style scoped lang="scss">
  .collection-grid {
    position: relative;
    margin-bottom: $grid-gutter * 2;

    &__loading {
      position: absolute;
      width: 100%;
      display: flex;
      justify-content: center;
    }

    &__pagination {
      margin-bottom: $grid-gutter * 2;

      @include tablet-up {
        margin-bottom: 50px;
      }
    }

    .column {
      @include mobile-only {
        padding: 0 4px 18px;
      }
    }
  }
</style>
